import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";

import LineSeparator from "../../common/components/LineSeparator";
import { PALETTE } from "../../common/ThemeConstants";
import Logo from "../../common/images/logoFree.png";

export default function Loading({
  text = "Caricamento",
  paddingTop = "130px",
}) {

  // Define the animation style
  const shimmerStyle = {
    position: "relative",
    overflow: "hidden",
    maxWidth: "100%",
  };

  const shimmerAfterStyle = {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: `linear-gradient(to right, ${PALETTE.LIGHTGRAY}, ${PALETTE.KINDALIGHTGRAY}, ${PALETTE.LIGHTGRAY})`,
    backgroundSize: "200% 100%",
    animation: "shimmer 2s infinite",
    borderRadius: 20
  };

  // Add the keyframes animation to the document
  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = `
      @keyframes shimmer {
        0% {
          background-position: -200% 0;
        }
        100% {
          background-position: 200% 0;
        }
      }
    `;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  return (
    <Container
      className="align-self-center text-center"
      style={{ paddingTop: paddingTop, width: "300px" }}
    >
      <div style={shimmerStyle}>
        <img
          width={200}
          src={Logo}
          alt="Federico Bartoli PT"
          style={{ maxWidth: "100%", position: "relative", zIndex: 1, opacity: 0.3 }}
        />
        <div style={shimmerAfterStyle}></div>
      </div>
      <Container style={{ maxWidth: "100%", marginTop: 50 }}>
        <LineSeparator text={text} textColor={PALETTE.KINDAGRAY} color={PALETTE.KINDALIGHTGRAY} />
      </Container>
    </Container>
  );
}
